module.exports = __webpack_public_path__ + "img/isa_app_logo.c11875b7.png";